<template>
  <div v-if="!!order" class="cart-list">
    <div class="orders-item-heading">
      <div class="orders-item-heading__invoice" :class="{ 'saved-order': order.order_status == 1 }">
        {{ order.order_status == 1 ? 'Saved ' : '' }} {{ invoice(order) }}
      </div>

      <div class="orders-item-heading__summ">
        {{ trans.text.orders.sum }}: {{ getOrderTotalQuantity(order) }} {{ trans.text.orders['pcs'] }} /
        {{ getOrderTotalPrice(order) }}

        <button v-if="needCollapse" class="btn btn-collapse" @click.prevent="collapsed = !collapsed" :class="{ collapsed: collapsed }"></button>
      </div>
    </div>
    <div v-show="!collapsed">
      <div v-if="false" class="orders-item-shipping">
        <p>{{ trans.text.orders.shipping }}</p>
        <p class="orders-item-shipping__summ">€ 119.00</p>
      </div>
      <div v-for="product in products(order)" class="cart-item">
        <div class="cart-item__wrapper">
          <a
            :href="`/en/products/${product.build.model.slug}`"
            class="cart-item__image"
            target="_blank"
          >
            <img :alt="getProductTitle(product)" :src="getProductImage(product)"/>
          </a>
          <div class="cart-item__info">
            <a
              :href="`/en/products/${product.build.model.slug}`"
              class="cart-item__name"
              target="_blank"
            >
              {{ getProductTitle(product) }}
            </a>
            <p
              v-if="showFrameNumber(product)"
              class="cart-item__number">
              {{ trans.text.orders['frameNumber'] }} {{ getFrameNumber(product) }}/999
            </p>
            <span class="cart-item__detail">{{ getModelDescription(product) }}</span>
          </div>
          <div class="cart-item-wrap">
            <p class="cart-item__qty">{{ getProductQuantity(product) }}</p>
            <p class="cart-item__total">{{ getProductTotalPrice(product) }}</p>
            <span
              v-if="showFrameNumber(product) && false"
              class="cart-item__exclusive">
              {{ trans.text.orders['excPurchasePrice'] }}
            </span>
            <span
              v-if="product.purchase_type === 'reservation'"
              class="cart-item__exclusive">
              {{ trans.text.orders['reservationPrice'] }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="order.order_status == 1 && order.ordered_payments_count == 1 && order.other_payments_count == 0" class="checkout-controls with-margin">
        <button
        :class="{'is-disabled': isLoading, 'btn-gray': isLoading, 'btn-green': !isLoading}"
          :disabled="isLoading"
          class="btn btn-block btn-paypal_pay blue"
          @click.prevent="payWithPaypal()">
          <span v-if="!isLoading">
            Pay with <span class="paypal-ic"></span>
          </span>
          <span v-if="isLoading">
            Please, wait...
          </span>
        </button>
      </div>
      <div class="orders-item-status">
        <div class="orders-item-status-list">
          <div v-for="status in visibleStatuses"
               :class="getStatusClass(status, order)"
               class="orders-item-status-item">
            <div class="orders-item-status-item__dot"></div>
            <div class="orders-item-status-item__name">{{ getStatusTitle(status, order) }}</div>
            <div class="orders-item-status-item__line"></div>
            <div class="orders-item-status-item__date">{{ getStatusDate(status, order) }}</div>
          </div>
        </div>
        <div class="orders-item-status-info">
          <p v-html="getOrderDeliveryAddress(order)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "OrderItemComponent",
  props: {
    statuses: {
      required: true
    },
    order: {
      required: true
    },
    trans: {
      required: true
    },
    needCollapse: false,
  },
  data() {
    return {
      canceled: false,
      partialPaid: false,
      visibleStatuses: [],
      taxTitle: null,
      isLoading: false,
      collapsed: this.needCollapse
    }
  },
  computed: {
    ...mapGetters(['storage', 'getAuthUser']),
    language() {
      return this.$store.state.language.language;
    },
  },
  mounted() {
    if (this.order !== undefined) {
      this.checkIfCanceled();
      this.setTax()
    }
  },
  watch: {
    statuses: function () {
      this.checkIfCanceled()
    },
    order: function (val) {
      if (!!val) {
        this.checkIfCanceled();
      }
    }
  },
  methods: {
    setTax() {
      this.taxTitle = this.order['delivery_address'].country.tax.title
    },
    products(order) {
      return order.basket.items
    },
    checkIfCanceled() {
      let filtered = this.order['order_status_history'].filter(item => {
        return item.hasOwnProperty('rel_status') && (item.rel_status.id === 7 || item.rel_status.id === 8);
      })
      let partialFiltered = this.order['order_status_history'].filter(item => {
        return item.hasOwnProperty('rel_status') && (item.rel_status.id === 9);
      })
      let fullPaidFiltered = this.order['order_status_history'].filter(item => {
        return item.hasOwnProperty('rel_status') && (item.rel_status.id === 2);
      })

      this.canceled = filtered.length > 0;
      this.partialPaid = fullPaidFiltered.length === 0 && partialFiltered.length > 0;

      this.filterStatuses();
    },
    filterStatuses() {
      if (this.statuses.length > 0) {
        let availableStatuses;

        this.visibleStatuses = [...this.statuses]

        if (this.canceled) {
          availableStatuses = [1, 2, 7, 8]
        } else if (this.partialPaid) {
          let statuses = [];
          for (let i = 0; i < this.visibleStatuses.length; i++) {
            if (i !== 1 && this.visibleStatuses[i].id !== 9) {
              statuses[i] = this.visibleStatuses[i];
            }
          }
          statuses[1] = this.statuses.find(item => {
            return item.id === 9;
          });
          this.visibleStatuses = [...statuses]
          availableStatuses = [1, 9, 3, 4, 5, 6]
        } else {
          availableStatuses = [1, 2, 3, 4, 5, 6]
        }
        if (this.visibleStatuses) {
          this.visibleStatuses = this.visibleStatuses.filter(item => {
            return availableStatuses.indexOf(item.id) !== -1
          })
        }
      }
    },
    invoice(order) {
      return `${this.trans.text.orders['orderWord']} ${order['invoice_number']} ${this.$moment(order.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY')}`;
    },
    getModelDescription(product) {
      return product.build['short_description'];
    },
    showFrameNumber(product) {
      return !!product.frame_number;
    },
    getFrameNumber(product) {
      let frameNumber = product.frame_number.toString();
      if (frameNumber.length === 2) {
        frameNumber = `0${frameNumber}`;
      }
      return frameNumber;
    },
    getStatusClass(status, order) {
      if (this.visibleStatuses.length > 0) {
        if (status.status === 'Paid' && order.failed === 1) {
          return 'is-active';
        }
        let filteredStatus = order['order_status_history'].filter(historyItem => {
          return parseInt(historyItem['rel_status'].id) === parseInt(status.id);
        });

        if (filteredStatus.length > 0 && (filteredStatus[0]['completed'] === 1 || filteredStatus[0].active === 1)) {
          return 'is-active';
        }
        return '';
      }
      return '';
    },
    getStatusDate(status, order) {
      if (status.status === 'Paid' && order.failed === 1) {
        return '';
      }
      let filteredStatus = order['order_status_history'].filter(historyItem => {
        return parseInt(historyItem['rel_status'].id) === parseInt(status.id);
      });

      if (filteredStatus.length > 0 && (filteredStatus[0]['completed'] === 1 || filteredStatus[0].active === 1)) {
        return this.$moment(filteredStatus[0]['real_date']).format('DD.MM.YYYY HH:mm');
      }
      return '';
    },
    getOrderInvoiceNumber(order) {
      return `#${order.id}-${this.$moment(order['created_at']).format('DD.MM.YYYY')}`;
    },
    getOrderTotalQuantity(order) {
      let qty = 0
      for (let item of order.basket.items) {
        qty += item.qty
      }
      return qty;
    },
    getOrderTotalPrice(order) {
      let price = 0;
      for (let product of order['basket']['items']) {
        price += this.getProductPrice(product, true);
      }
      if (order['discount_value'] !== null && order['discount_type'] !== null) {
        if (order['discount_type'] === 'value') {
          price -= order['discount_value']
        } else {
          price -= (price / 100 * order['discount_value'])
        }
      }
      return this.$crConverter(price / 100, 'EUR');
    },
    getStatusTitle(status, order) {
      if (status.status === 'Paid' && order.failed === 1) {
        return this.trans.text.statuses['Failed'];
      }

      return this.trans.text.statuses[status.status];
    },
    getOrderDeliveryAddress(order) {
      let deliveryAddress = order['delivery_address'];
      let address = '';
      if (deliveryAddress) {
        if (order['is_pickup']) {
          address = 'Forestal Technology Centre<br>';
        }
        address += deliveryAddress.country['country_name'];

        if (!!deliveryAddress.state) {
          address += `, ${deliveryAddress.state}`;
        }

        if (!!deliveryAddress.city) {
          address += `, ${deliveryAddress.city.town_name}`;
        }

        if (!!deliveryAddress.streetNo) {
          address += `, ${deliveryAddress.streetNo}`;
        }

        if (!!deliveryAddress.flat) {
          address += `, ${deliveryAddress.flat}`;
        }

        if (!!deliveryAddress.recipient) {
          address += `<br> ${deliveryAddress.recipient}`;
        }
      }

      return address;
    },
    getStorageLink(path) {
      return this.storage + path;
    },
    getProductImage(product) {
      return this.getStorageLink(product.build['media_content']['preview']);
    },
    getProductTitle(product) {
      return product.build['web_bike_title'];
    },
    getProductQuantity(product) {
      return product.qty;
    },
    getProductPrice(basketItem, clean = false) {
      let price = basketItem['amount']['price_total']

      if (clean) {
        return price;
      }

      return this.$crConverter(price / 100, 'EUR');
    },
    getProductTotalPrice(product) {
      let price = this.getProductPrice(product, true);
      return this.$crConverter(price / 100, 'EUR');
    },
    payWithPaypal() {
      this.isLoading = true;

      axios
        .post(this.$path + '/v2/checkout-saved-order/' + this.order.id, {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          })
        .then(response => {
          location.href = response.data.pay_url;
        })
        .catch(err => {
          this.isLoading = false;
        });
    }
  },
}
</script>

<style scoped>
  .saved-order {
    background-color: #C2E900;
    padding: 4px 8px;
    border-radius: 12px;
    margin-left: -8px;
  }

  .btn.is-disabled {
    cursor: not-allowed;
  }

  .btn-green.black{
    background: #1C1C1C;
    color: #fff;
  }
  .btn-green.blue{
    background: #EEEEEE;
    color: #000;
  }

  .paypal-ic{
    display: inline-block;
    vertical-align: middle;
    width: 101px;
    height: 26px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url('../../../images/icons/payPal.svg');
  }

  .btn-green.blue .paypal-ic{
    background-image: url('../../../images/icons/PayPal-blue.svg');
  }

  .btn-collapse {
    width: 16px;
    height: 16px;
    margin-left: 10px;
    background-image: url('../../../images/icons/arr-bottom.svg');
    background-repeat: no-repeat;
    background-position: center center;
    transform: rotateX(180deg);

    &.collapsed {
      transform: rotateX(0deg);
    }
  }
</style>
